export default function throwCustomError(
  error = new Error("File uploading has failed")
) {
  error.isImageError = true;
  throw error;
}
